/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-undef */
import React from 'react';
import { withStyles } from '@material-ui/core';
import SVG from 'react-inlinesvg';
import images from '../../themes/assets';
import styles from './styles';

class HeaderIcon extends React.PureComponent {
  /**
   * @name render
   * @description react component lifecycle method
   */
  render() {
    const styleIcon = code => code.replace(/height=".*?"/g, 'height="1.9em"');
    return (
      <span className={this.props.classes.itemDividerIcon}>
        <SVG
          description="notificationsByDate"
          title="notificationsByDate"
          preProcessor={styleIcon}
          uniqueHash="{new Date()}"
          uniquifyIDs
          src={images.EventGrayIcon}
        />
      </span>
    );
  }
}

export default withStyles(styles)(HeaderIcon);
